import { render, staticRenderFns } from "./ProjectKanban.vue?vue&type=template&id=d100242a&scoped=true"
import script from "./ProjectKanban.vue?vue&type=script&lang=js"
export * from "./ProjectKanban.vue?vue&type=script&lang=js"
import style0 from "./ProjectKanban.vue?vue&type=style&index=0&id=d100242a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d100242a",
  null
  
)

export default component.exports